import { News } from '@/models/news'
import { DateTime } from 'luxon'
import Parser from 'rss-parser'
import { mockBackend } from './environment'
import { Endpoints, url as wsURL } from './web-services'

const MAX_DAYS_DIFF = 365

export async function news (): Promise<News[]> {
  const parser = new Parser()
  let url: string
  if (mockBackend()) {
    url = '/mock-backend/news.rss'
  } else {
    url = wsURL(Endpoints.news)
  }
  const rss = await parser.parseURL(url)
  return rss.items.map((item): News | null => {
    if (!item.pubDate) { return null }
    const date = DateTime.fromRFC2822(item.pubDate)
    if (-date.diffNow('days').days > MAX_DAYS_DIFF) { return null }
    return {
      title: item.title,
      html: item.content
    } as News
  }).filter(item => { return item !== null }) as News[]
}
